import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "pb-3" }, " Your feedback is valuable to us. Please share your thoughts or let us know if you find this app useful. ", -1)
const _hoisted_3 = { class: "form-outline mb-4 flex-grow-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "link"
}, "Message", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column text-center"
}

import { Utils } from "@/classes/utils/utils";
import ModalDialog from "@/components/Modals/ModalDialog.vue";
import { useDataStore } from "@/store/data-store";
import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackDialog',
  setup(__props, { expose }) {

const dataStore = useDataStore();

let data = reactive({
	show: false,
	isError: false,
	message: null as string,
	isSubmitted: false,
});

async function send(){
	if(!data.message || data.message.trim().length == 0){
		return;
	}

	var result = await dataStore.sendFeedback(window.location.href, data.message);
	if(!result){
		data.isError = true;
		return;
	}
	console.log("Feedback result", result);
	data.isSubmitted = true;
	await Utils.delay(3000);
	hide();
}

function show() {
	data.show = true;
	data.isSubmitted = false;
	data.message = null;
	data.isError = false;
}

function hide() {
	data.show = false;
}

expose({
	show
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalDialog, {
    visible: _unref(data).show,
    title: !_unref(data).isSubmitted ? 'Give feedback' : null
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (!_unref(data).isSubmitted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createElementVNode("textarea", {
                  name: "link",
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).message) = $event)),
                  rows: "5"
                }, null, 512), [
                  [_vModelText, _unref(data).message]
                ])
              ]),
              (_unref(data).isError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Error sending feedback, please try again later. "))
                : _createCommentVNode("", true),
              _createElementVNode("div", { class: "ml-auto mt-4" }, [
                _createElementVNode("button", {
                  class: "btn-link me-4",
                  onClick: hide
                }, "Close"),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: send
                }, "Send")
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(data).isSubmitted)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_6, " Thank you for your feedback "))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})